import { NgModule } from "@angular/core";
import { CounterTextPipe } from "./counter-text.pipe";

@NgModule({
    declarations: [CounterTextPipe],
    exports: [CounterTextPipe]
})
export class CounterTextModule {
}